import { useState, type FC } from 'react';
import { HelpCircle, RotateCcw, Home, BookOpen, GraduationCap } from 'lucide-react';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { useNavigate } from 'react-router-dom';

interface HelpButtonProps {
  onRestartPageTour: () => void;
  onRestartWelcomeTour: () => void;
  onOpenGlossary?: () => void;
}

export const HelpButton: FC<HelpButtonProps> = ({
  onRestartPageTour,
  onRestartWelcomeTour,
  onOpenGlossary,
}) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const items: MenuProps['items'] = [
    {
      key: 'page-tour',
      icon: <RotateCcw className="w-3.5 h-3.5" />,
      label: 'Revoir le tour de cette page',
      onClick: () => { setOpen(false); onRestartPageTour(); },
    },
    {
      key: 'welcome-tour',
      icon: <Home className="w-3.5 h-3.5" />,
      label: "Revoir le tour d'accueil",
      onClick: () => { setOpen(false); onRestartWelcomeTour(); },
    },
    { type: 'divider' },
    {
      key: 'learning-hub',
      icon: <GraduationCap className="w-3.5 h-3.5" />,
      label: "Centre d'apprentissage",
      onClick: () => { setOpen(false); navigate('/learning'); },
    },
    {
      key: 'glossary',
      icon: <BookOpen className="w-3.5 h-3.5" />,
      label: 'Glossaire',
      onClick: () => { setOpen(false); onOpenGlossary?.(); },
    },
  ];

  return (
    <Dropdown
      menu={{ items }}
      trigger={['click']}
      open={open}
      onOpenChange={setOpen}
    >
      <button
        className="flex h-8 w-8 items-center justify-center rounded-lg border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-600 hover:text-blue-600 dark:hover:text-blue-400 transition-all duration-200"
        title="Aide et tours guides"
      >
        <HelpCircle className="w-4 h-4" />
      </button>
    </Dropdown>
  );
};

export default HelpButton;
